import * as React from 'react';
import { useState, useEffect } from 'react'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Box, IconButton, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import axios from 'axios'
import BookService from './BookService';
import { useParams } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { GoogleMap, Marker } from '@react-google-maps/api';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import SalonReviewsDialog from './SalonReviewsDialog';
import { useHistory } from "react-router-dom";
//--
// import * as React from 'react';
// import { useState, useEffect } from 'react'
// import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
// import CardContent from '@mui/material/CardContent';
// import { Box, IconButton, Tooltip } from '@mui/material';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
// import axios from 'axios'
// import BookService from './BookService';
// import { useParams } from 'react-router-dom';
// import Paper from '@mui/material/Paper';
// import { useLocation } from 'react-router-dom';
// import { GoogleMap, Marker } from '@react-google-maps/api';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import StarIcon from '@mui/icons-material/Star';
// import StarHalfIcon from '@mui/icons-material/StarHalf';
// import StarBorderIcon from '@mui/icons-material/StarBorder';

export default function SalonDetails(props) {
  const [services, setServices] = useState([{}])
  const [bookingVisible, setBookingVisible] = useState(false)
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [booking, setBooking] = useState({ apptDate: "", apptTime: "" })

  const { id } = useParams();
  const [salon, setSalon] = useState(null);
  const servicesUrl = (process.env.REACT_APP_SERVER) ? `https://salonserver-k8m8.onrender.com/services` : `http://localhost:3001/services`
  const salonsUrl = (process.env.REACT_APP_SERVER) ? `https://salonserver-k8m8.onrender.com/salons/${id}` : `http://localhost:3001/salons/${id}`
  const state = useLocation();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const history = useHistory();

  const [user, setUser] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const [openReviews, setOpenReviews] = useState(false);

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;
    const totalStars = 5;

    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<StarIcon key={`full-${i}`} fontSize="small" color="warning" />);
    }

    if (hasHalfStar) {
      stars.push(<StarHalfIcon key="half" fontSize="small" color="warning" />);
    }

    const remaining = totalStars - stars.length;
    for (let i = 0; i < remaining; i++) {
      stars.push(<StarBorderIcon key={`empty-${i}`} fontSize="small" color="warning" />);
    }

    return stars;
  };


  const filteredServices = (services) => {
    const curServ = services.filter(
      (service) => service.salon_id === salon.data.id
    );
    return curServ
  }

  const handleBooking = () => {
    // console.log('user in handleBooking', user)
    if (!user?.id) {
      alert('Please login to book your appointment')
      history.push('/');
    }
    setBookingVisible(true)
  }

  const favouritesUrl = process.env.REACT_APP_SERVER
    ? 'https://salonserver-k8m8.onrender.com/favourites'
    : 'http://localhost:3001/favourites';

  useEffect(() => {

    // fetch(salonsUrl)
    //   .then((res) => res.json())
    //   .then((data) => setSalon(data));
    const getSalonData = async () => {
      try {
        const response = await axios.get(salonsUrl);
        setSalon(response.data);
      } catch (err) {
        setError(err.message);
        setSalon(null);
      } finally {
        setLoading(false);
      }
    };
    const getServicesData = async () => {
      try {
        const response = await axios.get(
          servicesUrl
        );
        setServices(response.data);
      } catch (err) {
        setError(err.message);
        setServices(null);
      } finally {
        setLoading(false);
      }
    };
    const setUserData = async () => {
      const savedUser = await localStorage.getItem('user');
      // console.log('ddd', savedUser)
      if (savedUser) {
        setUser(JSON.parse(savedUser));
      }
    }
    const checkFavorite = async () => {
      try {
        const response = await axios.get(favouritesUrl, {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": ` ${localStorage.getItem("token")}  `,
          },
        });
        const fetchedFavorites = response.data;
        // console.log('Fetched favorites:', fetchedFavorites);
        const salonIds = fetchedFavorites.map(salon => salon.id);
        // console.log('Extracted salon IDs:', salonIds);
        const isFavorite = salonIds.includes(Number(id));
        // console.log('isFavorite', isFavorite)
        setIsFavorite(isFavorite);
      } catch (error) {
        console.error('Error checking favorite:', error);
      }
    };
    getSalonData()
    setUserData()
    getServicesData()
    checkFavorite()
  }, [id]);

  if (!salon) return <p>Loading...</p>;
  const defaultCenter = { lat: 20.5937, lng: 78.9629 }; // India

  const center = {
    lat: Number(salon.data.latitude),
    lng: Number(salon.data.longitude)
  };
  // console.log('goo', salon.latitude)

  const toggleFavorite = async (salonId) => {
    // console.log('user in toggleFavorite', user)
    if (!user || !user.id) {
      alert('Please login to add to favorites');
      return;
    }
    // console.log('salon id in toggleFavorite', salonId)
    try {
      if (isFavorite) {
        await axios.delete(favouritesUrl, {

          headers: { Authorization: ` ${localStorage.getItem('token')}` },
          params: { salon_id: salonId },
        })

        alert('Removed from favorites');
      } else {
        await axios.post(favouritesUrl, {
          salon_id: salonId
        }, { headers: { Authorization: ` ${localStorage.getItem('token')}` } })
        alert('Added to favorites');
      }
      setIsFavorite(!isFavorite);
    } catch (error) {
      console.error('Error toggling favorite:', error);
    }
  };


  // New function to open Google Maps directions
  const handleGetDirections = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${center.lat},${center.lng}`,
      '_blank'
    );
  };


  return (
    <Box>
      <Box
        sx={{
          backgroundImage: `url(${salon.data.get_image_url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          textAlign: 'center',
          p: 4,
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            padding: 4,
            borderRadius: 2,
            maxWidth: 800,
          }}
        >
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            {salon.data.name}

          </Typography>
          <Typography variant="h5" gutterBottom>ID:  {salon.data.id}</Typography>

          <Typography variant="h6">{salon.data.description}</Typography>
        </Box>
      </Box>
      {/* {console.log('userIdddd', user)} */}

      <Box
        sx={{
          mt: -8,
          mx: 'auto',
          maxWidth: 1000,
          p: 3,
        }}
      >
        <Card elevation={5}>
          <CardContent>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              {salon.data.name}
              {/* {console.log('salon name', salon)              } */}
              {/* <Box sx={{ mt: 2 }}> */}
              <Tooltip title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}>
                <IconButton color={isFavorite ? 'secondary' : 'default'} onClick={() => toggleFavorite(salon.data.id)}>
                  {isFavorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                </IconButton>
              </Tooltip>
              {/* </Box> */}
            </Typography>
            {/* <Typography variant="body2" color="text.secondary">
              Rating: {salon.data.average_rating}
              {console.log('reviews', salon.data.ratings_count)}
              {' '}
              {renderStars(salon.data.average_rating)}
              {' '}
              ({salon.data.ratings_count})
              {console.log('reviews', salon.data.ratings_count)}
            </Typography> */}

            <Box
              onClick={() => setOpenReviews(true)}
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            >
              <Typography variant="body2" color="text.secondary">
                {' '}
                {renderStars(salon.data.average_rating)}
                {' '}
                {salon.data.average_rating}
                {' '}
                ({salon.data.reviews_count} reviews)
                {/* {console.log('reviews', salon.reviews_count)} */}
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', md: 'row' }}
              gap={4}
              mt={2}
            >
              <SalonReviewsDialog
                open={openReviews}
                onClose={() => setOpenReviews(false)}
                reviews={salon.data.reviews}
              />
              <Paper elevation={1} sx={{ p: 2, flex: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Address
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {salon.data.address1}<br />
                  {salon.data.address2}<br />
                  {salon.data.pincode}<br />
                  {salon.data.city}
                  {salon.mobile}<br />
                </Typography>
              </Paper>

              <Paper elevation={1} sx={{ p: 2, flex: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Salon Timings
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>Opens:</strong> {new Date(salon.data.opens).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br />
                  <strong>Closes:</strong> {new Date(salon.data.closes).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </Typography>
              </Paper>

              <Paper elevation={1} sx={{ p: 2, flex: 1 }}>
                {/* {console.log('salon data', salon.data)} */}
                {/* <Box sx={{ mt: 2 }}>
                  <Tooltip title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}>
                    <IconButton color={isFavorite ? 'secondary' : 'default'} onClick={() => toggleFavorite(salon.data.id)}>
                      {isFavorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                    </IconButton>
                  </Tooltip>
                </Box> */}
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Services Offered
                </Typography>
                <ul style={{ paddingLeft: '1rem', marginTop: 0 }}>
                  {filteredServices(services).map((service) => (
                    <li key={service.id}>
                      <Typography variant="body2" color="text.secondary">
                        {service.stype} – ₹{service.sprice}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </Paper>
            </Box>
          </CardContent>
          {/* {console.log('goo', salon)} */}
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '200px' }}
            center={center}
            zoom={15}
          >
            <Marker position={{ lat: salon.data.latitude, lng: salon.data.longitude }} />
          </GoogleMap>

          {/* ✅ New "Get Directions" button */}
          <Box display="flex" justifyContent="center" my={2}>
            <Button variant="outlined" onClick={handleGetDirections}>
              Get Directions
            </Button>
          </Box>

          <CardActions sx={{ justifyContent: 'center', p: 2 }}>
            <Button variant="contained" onClick={handleBooking}>
              Book Your Service
            </Button>
          </CardActions>
        </Card>


        {bookingVisible && (
          <Box mt={4}>

            <BookService
              booking={booking}
              setBooking={setBooking}
              salonId={salon.data.id}
              salonName={salon.data.name}
              salonEmail={salon.data.email}
              salonLandline={salon.data.landline}
              salonMobile={salon.data.mobile}
              salonOpens={salon.data.opens}
              salonCloses={salon.data.closes}
              services={filteredServices(services)}
              clientName={user.first_name + ' ' + user.last_name}
              clientEmail={user.email}
              clientMobile={user.mobile}
              userId={user.id}
              user={user}
              setBookingVisible={setBookingVisible}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}


// import * as React from 'react';
// import { useState, useEffect } from 'react'
// import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
// import CardContent from '@mui/material/CardContent';
// import { Box, IconButton, Tooltip } from '@mui/material';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
// import axios from 'axios'
// import BookService from './BookService';
// import { useParams } from 'react-router-dom';
// import Paper from '@mui/material/Paper';
// import { useLocation } from 'react-router-dom';
// import { GoogleMap, Marker } from '@react-google-maps/api';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import StarIcon from '@mui/icons-material/Star';
// import StarHalfIcon from '@mui/icons-material/StarHalf';
// import StarBorderIcon from '@mui/icons-material/StarBorder';

// export default function SalonDetails(props) {
//   const [services, setServices] = useState([{}])
//   const [bookingVisible, setBookingVisible] = useState(false)
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [booking, setBooking] = useState({ apptDate: "", apptTime: "" })

//   const { id } = useParams();
//   const [salon, setSalon] = useState(null);
//   const servicesUrl = (process.env.REACT_APP_SERVER) ? `https://salonserver-k8m8.onrender.com/services` : `http://localhost:3001/services`
//   const salonsUrl = (process.env.REACT_APP_SERVER) ? `https://salonserver-k8m8.onrender.com/salons/${id}` : `http://localhost:3001/salons/${id}`
//   const state = useLocation();
//   const { search } = useLocation();
//   const queryParams = new URLSearchParams(search);

//   const [user, setUser] = useState(null);
//   const [isFavorite, setIsFavorite] = useState(false);

//   const renderStars = (rating) => {
//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;
//     const totalStars = 5;

//     const stars = [];
//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<StarIcon key={`full-${i}`} fontSize="small" color="warning" />);
//     }
//     if (hasHalfStar) {
//       stars.push(<StarHalfIcon key="half" fontSize="small" color="warning" />);
//     }
//     const remaining = totalStars - stars.length;
//     for (let i = 0; i < remaining; i++) {
//       stars.push(<StarBorderIcon key={`empty-${i}`} fontSize="small" color="warning" />);
//     }
//     return stars;
//   };

//   const filteredServices = (services) => {
//     const curServ = services.filter(
//       (service) => service.salon_id === salon.data.id
//     );
//     return curServ
//   }

//   const handleBooking = () => {
//     if (!user?.id)
//       alert('Please login to book your appointment')
//     else
//       setBookingVisible(true)
//   }

//   const favouritesUrl = process.env.REACT_APP_SERVER
//     ? 'https://salonserver-k8m8.onrender.com/favourites'
//     : 'http://localhost:3001/favourites';

//   useEffect(() => {
//     fetch(salonsUrl)
//       .then((res) => res.json())
//       .then((data) => setSalon(data));

//     const getServicesData = async () => {
//       try {
//         const response = await axios.get(servicesUrl);
//         setServices(response.data);
//       } catch (err) {
//         setError(err.message);
//         setServices(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     const setUserData = async () => {
//       const savedUser = await localStorage.getItem('user');
//       if (savedUser) {
//         setUser(JSON.parse(savedUser));
//       }
//     }

//     const checkFavorite = async () => {
//       try {
//         const response = await axios.get(favouritesUrl, {
//           headers: {
//             "Content-Type": "application/json",
//             "Accept": "application/json",
//             "Authorization": ` ${localStorage.getItem("token")}  `,
//           },
//         });
//         const fetchedFavorites = response.data;
//         const salonIds = fetchedFavorites.map(salon => salon.id);
//         const isFavorite = salonIds.includes(Number(id));
//         setIsFavorite(isFavorite);
//       } catch (error) {
//         console.error('Error checking favorite:', error);
//       }
//     };

//     setUserData()
//     getServicesData()
//     checkFavorite()
//   }, [id]);

//   if (!salon) return <p>Loading...</p>;

//   const center = {
//     lat: Number(salon.data.latitude),
//     lng: Number(salon.data.longitude)
//   };

//   const toggleFavorite = async (salonId) => {
//     if (!user || !user.id) {
//       alert('Please login to add to favorites');
//       return;
//     }
//     try {
//       if (isFavorite) {
//         await axios.delete(favouritesUrl, {
//           headers: { Authorization: ` ${localStorage.getItem('token')}` },
//           params: { salon_id: salonId },
//         })
//         alert('Removed from favorites');
//       } else {
//         await axios.post(favouritesUrl, {
//           salon_id: salonId
//         }, { headers: { Authorization: ` ${localStorage.getItem('token')}` } })
//         alert('Added to favorites');
//       }
//       setIsFavorite(!isFavorite);
//     } catch (error) {
//       console.error('Error toggling favorite:', error);
//     }
//   };

//   // ✅ New function to open Google Maps directions
//   const handleGetDirections = () => {
//     window.open(
//       `https://www.google.com/maps/dir/?api=1&destination=${center.lat},${center.lng}`,
//       '_blank'
//     );
//   };

//   return (
//     <Box>
//       {/* ... your hero section ... */}
//       <Box
//         sx={{ mt: -8, mx: 'auto', maxWidth: 1000, p: 3 }}
//       >
//         <Card elevation={5}>
//           <CardContent>
//             {/* ... salon details ... */}
//           </CardContent>

//           {/* Map + Directions Button */}
//           <GoogleMap
//             mapContainerStyle={{ width: '100%', height: '200px' }}
//             center={center}
//             zoom={15}
//           >
//             <Marker position={center} />
//           </GoogleMap>

//           {/* ✅ New "Get Directions" button */}
//           <Box display="flex" justifyContent="center" my={2}>
//             <Button variant="outlined" onClick={handleGetDirections}>
//               Get Directions
//             </Button>
//           </Box>

//           <CardActions sx={{ justifyContent: 'center', p: 2 }}>
//             <Button variant="contained" onClick={handleBooking}>
//               Book Your Service
//             </Button>
//           </CardActions>
//         </Card>

//         {/* Booking modal */}
//         {bookingVisible && (
//           <Box mt={4}>
//             <BookService
//               booking={booking}
//               setBooking={setBooking}
//               salonId={salon.data.id}
//               salonName={salon.data.name}
//               salonEmail={salon.data.email}
//               salonLandline={salon.data.landline}
//               salonMobile={salon.data.mobile}
//               salonOpens={salon.data.opens}
//               salonCloses={salon.data.closes}
//               services={filteredServices(services)}
//               clientName={user.first_name + ' ' + user.last_name}
//               clientEmail={user.email}
//               clientMobile={user.mobile}
//               userId={user.id}
//               user={user}
//               setBookingVisible={setBookingVisible}
//             />
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// }
